'use strict';

/* globals RELATIVE_PATH, ajaxify, socket, app */

require([RELATIVE_PATH + '/plugins/nodebb-plugin-lessons/static/vendor/vue.js'], function (Vue) {
	var internals = {};

	Vue.mixin({
		methods: {
			saveFilePermissions: function (fileName) {
				internals.saveFilePermissions(fileName);
			},
		},
	});

	internals.saveFilePermissions = function (fileName) {
		socket.emit('plugins.filePermissionSockets.saveFileFromGroupPrivileges', { fileName, groupName: ajaxify.data.group.name }, function (err) {
			if (err) {
				return app.alertError(err.message);
			}
		});
	};
});
